<template>
	<div class="leaderboard-container">
		<GlobalHeader />
		<div v-if="loaded" class="container mrgnbtm">
			<div v-if="user?.user">
				<h1 class="text-center mb-4">Scorebord</h1>
				
				<!-- Filter by Speltak -->
				<div class="row mb-4">
					<div class="col-12 col-md-6 mx-auto">
						<label for="speltak-filter" class="form-label">Filter op Speltak:</label>
						<select 
							id="speltak-filter" 
							class="form-select" 
							v-model="selectedSpeltak"
							@change="filterLeaderboard"
						>
							<option value="">Alle Speltakken</option>
							<option v-for="speltak in speltakList" :key="speltak" :value="speltak">
								{{ speltak }}
							</option>
						</select>
					</div>
				</div>
				
				<!-- Leaderboard Table -->
				<div class="row">
					<div class="col-12">
						<div v-if="loading" class="text-center">
							<p>Laden...</p>
						</div>
						<div v-else-if="filteredLeaderboard.length === 0" class="text-center">
							<p>Geen resultaten gevonden.</p>
						</div>
						<div v-else class="table-responsive">
							<table class="table table-striped table-hover">
								<thead>
									<tr>
										<th scope="col" style="width: 50px;">#</th>
										<th scope="col">Naam</th>
										<th scope="col">Speltak</th>
										<th scope="col" class="text-end">Zakken verkocht</th>
										<th scope="col" class="text-end">Aantal bestellingen</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(entry, index) in filteredLeaderboard" :key="entry.user">
										<td class="fw-bold">{{ index + 1 }}</td>
										<td>{{ entry.name }}</td>
										<td>{{ entry.speltak || '-' }}</td>
										<td class="text-end fw-bold">{{ entry.totalBags }}</td>
										<td class="text-end">{{ entry.orderCount }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="row mrgnbtm">
				<loginComp />
			</div>
		</div>
	</div>
</template>

<script>
import GlobalHeader from "@/components/GlobalHeader.vue";
import loginComp from "@/components/loginComp.vue";
import { getLeaderboard, getSpeltakList } from "../services/OrderService";
import { getUser } from "../services/UserService";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

export default {
	name: "LeaderboardView",
	components: {
		GlobalHeader,
		loginComp
	},
	data() {
		return {
			leaderboard: [],
			speltakList: [],
			selectedSpeltak: "",
			user: {},
			loaded: false,
			loading: false
		};
	},
	computed: {
		filteredLeaderboard() {
			if (!this.selectedSpeltak) {
				return this.leaderboard;
			}
			return this.leaderboard.filter(entry => entry.speltak === this.selectedSpeltak);
		}
	},
	methods: {
		getUser() {
			getUser().then((response) => {
				this.user = response;
			}).finally(() => {
				this.loaded = true;
			});
		},
		setDefaultSpeltak() {
			// Set default filter to current user's Speltak
			if (this.user?.user && this.leaderboard.length > 0 && !this.selectedSpeltak) {
				const currentUserEntry = this.leaderboard.find(entry => entry.user === this.user.user);
				if (currentUserEntry?.speltak) {
					// Make sure the Speltak exists in the list
					if (this.speltakList.includes(currentUserEntry.speltak)) {
						this.selectedSpeltak = currentUserEntry.speltak;
					}
				}
			}
		},
		async loadLeaderboard() {
			this.loading = true;
			try {
				const data = await getLeaderboard();
				this.leaderboard = data || [];
			} catch (error) {
				console.error("Error loading leaderboard:", error);
				this.leaderboard = [];
			} finally {
				this.loading = false;
			}
		},
		async loadSpeltakList() {
			try {
				const data = await getSpeltakList();
				this.speltakList = data || [];
			} catch (error) {
				console.error("Error loading Speltak list:", error);
				this.speltakList = [];
			}
		},
		filterLeaderboard() {
			// Filtering is handled by computed property
			// This method is here for potential future use
		}
	},
	mounted() {
		this.getUser();
	},
	watch: {
		user: {
			handler(newUser) {
				if (newUser?.user) {
					// Load both in parallel
					Promise.all([
						this.loadLeaderboard(),
						this.loadSpeltakList()
					]).then(() => {
						// Set default after both are loaded
						this.setDefaultSpeltak();
					});
				}
			}
		}
	}
};
</script>

<style scoped>
.leaderboard-container {
	min-height: 100vh;
}

.table {
	background-color: white;
}

.table thead {
	background-color: #f8f9fa;
}

.table th {
	border-bottom: 2px solid #dee2e6;
}
</style>
